import { useTranslation } from "react-i18next";
import {
  ChevronDown,
  ScanFace,
  PersonStanding,
  User,
  Shapes,
  Rotate3d,
  Frame,
} from "@digital-twins/design-system/icons";
import { Text } from "@/components/ui/Text";
import type { SubjectReferenceTipsProps } from "@/types/creative-library";

export function SubjectReferenceTips({ kind }: SubjectReferenceTipsProps) {
  const { t } = useTranslation("app");
  const views = t(`creativeLibrary.referenceTips.${kind}.views`, {
    returnObjects: true,
  });
  const icons =
    kind === "person"
      ? [ScanFace, User, PersonStanding]
      : [Shapes, Rotate3d, Frame];
  return (
    <div
      className="flex min-w-0 flex-col gap-3"
      data-testid="subject-reference-tips"
    >
      <Text size="sm" color="muted">
        {t(`creativeLibrary.referenceTips.${kind}.intro`)}
      </Text>
      <details className="group rounded-xl border border-border bg-background">
        <summary
          className="flex cursor-pointer list-none items-center justify-between gap-3 rounded-xl p-3 text-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
          data-testid="subject-reference-tips-toggle"
        >
          {t("creativeLibrary.referenceTips.title")}
          <ChevronDown
            className="h-4 w-4 shrink-0 text-muted-foreground transition-transform group-open:rotate-180 motion-reduce:transition-none"
            aria-hidden="true"
          />
        </summary>
        <div className="flex flex-col gap-3 px-3 pb-3">
          <div className="grid grid-cols-1 gap-2 sm:grid-cols-3">
            {icons.map((Icon, index) => (
              <div
                key={index}
                className="flex min-w-0 items-center gap-3 rounded-lg border border-border bg-background p-3 sm:flex-col sm:text-center"
              >
                <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-primary/10 text-primary">
                  <Icon className="h-6 w-6" aria-hidden="true" />
                </div>
                <Text size="xs">
                  {views[index]}
                </Text>
              </div>
            ))}
          </div>
          <Text size="xs" color="muted">
            {t(`creativeLibrary.referenceTips.${kind}.quality`)}
          </Text>
          <Text size="xs" color="muted">
            {t("creativeLibrary.referenceTips.selection")}
          </Text>
        </div>
      </details>
    </div>
  );
}
